import React from "react";
import { Modal, Button } from "semantic-ui-react";
import "./style.css";

export class ModalExampleModal extends React.PureComponent {
  render() {
    const { content, isVisible, onClose } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <Modal
        open
        closeOnEscape
        closeOnDimmerClick
        onClose={onClose}
        dimmer="inverted"
        size="tiny"
        className="alert-modal-container"
      >
        <Modal.Content className="alert-modal-content" scrolling>
          {content}
        </Modal.Content>
        <Modal.Actions>
          <Button content="Ok" onClick={onClose} primary />
        </Modal.Actions>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AlertModal/index.jsx